export function bounceAnimation(element: HTMLElement): void {
  if (!element) return;

  let start: number | null = null;
  const duration: number = 300; // 애니메이션 지속 시간 (ms)
  const amplitude: number = 10; // 점프 높이 (px)

  function step(timestamp: number): void {
    if (start === null) start = timestamp;
    const progress: number = timestamp - start;
    const easing: number = Math.sin((progress / duration) * Math.PI); // 부드러운 점프 효과

    const translateY: number = -amplitude * easing; // 위로 이동하는 값
    element.style.transform = `translateY(${translateY}px)`;

    if (progress < duration) {
      requestAnimationFrame(step); // 계속 애니메이션 실행
    } else {
      element.style.transform = "translateY(0)"; // 원래 위치로 복귀
    }
  }

  requestAnimationFrame(step);
}
